/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviewImage/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function PreviewImage({
  children,
  url,
  viewPath = "/DesignSystem/PreviewImage",
  previewUrl,
  width = 100,
  height = 100,
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  objectFit = "cover",
  cursor,
  onClick,
  opacity = 1,
  maxWidth,
  maxHeight
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<img
  data-testid="PreviewImage.Image"
  data-view-path={viewPath}
 alt={""}
 src={previewUrl}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--w-1-Z1r1YsE': typeof width === 'number' ? `${width}px` : width,'--h-2-Z1r1YsE': typeof height === 'number' ? `${height}px` : height,'--bblr-3-Z1r1YsE': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z1r1YsE': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1r1YsE': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1r1YsE': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-7-Z1r1YsE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-8-Z1r1YsE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z1r1YsE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z1r1YsE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--of-11-Z1r1YsE': objectFit,'--c-12-Z1r1YsE': cursor,'--o-13-Z1r1YsE': opacity,'--mw-14-Z1r1YsE': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--mh-15-Z1r1YsE': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}